import { useState, useCallback } from 'react';

export function useTaskCalendar() {
  const now = new Date();
  const [year, setYear]               = useState(now.getFullYear());
  const [month, setMonth]             = useState(now.getMonth() + 1);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen]   = useState(false);

  const handleMonthChange = useCallback((y: number, m: number) => {
    setYear(y);
    setMonth(m);
    setSelectedDate(null);
  }, []);

  const handleDateClick = useCallback((date: string) => {
    setSelectedDate(date);
    setDialogOpen(true);
  }, []);

  const handleDialogClose = useCallback(() => {
    setDialogOpen(false);
  }, []);

  return { year, month, selectedDate, dialogOpen, handleMonthChange, handleDateClick, handleDialogClose };
}
